module.exports = __webpack_public_path__ + "img/two-layers.ff0a220f.svg";